import React, {Component} from 'react';

import './styles/Filter.css';

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            all: props.children,
            filterName: '',
            filterRole: ''
        };
    }
    
    updateFilter = (type, e) => {
        this.setState({
            ['filter' + type]: e.target.value.toLowerCase()
        })
    }

    filter(children, nameFilter, roleFilter, emptyMsg) {
        let filtered = children.filter(child => {
            return child.props.graduate.fullName.toLowerCase().includes(nameFilter);
        }).filter(child => {
            return child.props.graduate.roles.join('|').toLowerCase().includes(roleFilter);
        });

        if (filtered.length !== 0) {
            return (filtered);
        } else {
            return (<h2 className={'filter__empty-state'}>{emptyMsg}</h2>);
        }
    }
    
    render() {
        let options = [
            'UX Designer',
            'UI Designer',
            'Product Designer',
            'Developer',
            'Media Producer',
        ];
        
        return (
            <div className={'grid'}>
                <div className={'filter__container'}>
                    <select className={'filter__input'} defaultValue={''}
                    onChange={e => {this.updateFilter('Role', e)}}>
                        <option value=''>{'All Roles'}</option>
                        {options.map((option, i) => {
                            return(
                                    <option key={i} value={option}>{option}</option>   
                                )
                        })}
                    </select>
                    <input className={'filter__input'} 
                    placeholder={'Search'} 
                    onChange={e => {this.updateFilter('Name', e)}} 
                    type={'text'}>
                    </input>
                </div>
                {this.filter(this.props.children, this.state.filterName, this.state.filterRole, this.props.emptyMsg)}
            </div>
        )
    }
}
        
export default Filter;